<template>
	<main id="container" class="page-container page-festival">
		<div class="page-content">
			<div class="container">
				<div class="page-header">
					<div class="display-flex is-between">
						<page-header title="지역행사" />
					</div>
				</div>
				<div class="page-sub-header">
					<h3 class="page-sub-title"><span class="prima">동행축제와 함께 하는</span> 전국 행사를 만나보세요.</h3>
				</div>
				<div class="map-wrap">
					<div class="flex-l">
						<svg xmlns="http://www.w3.org/2000/svg" width="511" height="799" viewBox="0 0 511 799" fill="none" ref="mapSvg">
							<g filter="url(#filter0_d_1518_345)">
							<path class="region" data-name="jeonbuk" d="M261.032 434.155V445.319L234.36 468.013L224.63 501.063L232.375 522.041L222.737 542.302L207.053 533.388L198.674 540.053L159.295 541.044L152.983 520.333L147.663 518.258L140.359 525.465L130.271 514.026L116.213 516.183L110.811 532.304L89.1829 539.061L89.9087 525.649L85.4067 523.041L70.1733 527.457L68.6389 519.984L78.9109 505.13L95.1274 497.749L102.514 499.548L98.3707 491.717L73.8576 490.818L75.4747 484.786L94.668 469.748L103.139 468.573L103.948 464.157L115.304 464.249L113.861 457.134L105.666 450.019L119.631 445.246L115.304 440.472L103.856 444.97L95.2928 440.472L95.743 432.732L114.22 426.517L126.026 419.76H118.547L124.4 412.554L151.256 406.072L155.85 408.23L154.407 414.803L155.85 417.41L179.187 412.186L181.713 408.946L200.098 429.565L216.765 428.39L222.893 422.625L238.301 430.639L256.328 426.141L261.013 434.155H261.032ZM51.2005 487.953L47.3875 492.075L46.9924 495.674L53.626 489.321L51.1913 487.953H51.2005Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="jeonnam" d="M97.9939 713.014L100.153 713.473L99.2618 716.365L100.153 718.963L98.7014 723.609L96.4963 721.864L96.7352 716.31L96.4504 713.014H97.9847H97.9939ZM125.19 710.995L123.867 715.364L126.66 718.247L131.741 718.146L133.202 713.464L129.122 709.847L125.181 710.985L125.19 710.995ZM179.132 736.581L180.657 739.656L184.901 740.014L181.86 736.7L181.134 733.156L179.132 736.59V736.581ZM245.523 631.409L243.612 631.078L242.068 631.363L241.508 632.712L243.299 635.714L241.866 639.515L239.541 642.774L242.307 650.073L247.397 650.807L248.38 643.435L245.376 635.98L245.523 631.399V631.409ZM99.418 692.239L103.626 692.891V694.874L112.171 696.205L107.522 685.289L104.361 680.69L98.2971 681.828L96.9925 686.464L99.418 692.23V692.239ZM111.472 681.369L114.789 676.063L120.339 674.842L123.858 679.937L119.962 680.68L114.321 685.399L113.062 686.372L113.319 683.003L111.463 681.369H111.472ZM114.624 689.466L121.882 687.511L129.122 688.484L127.827 692.542L123.371 693.937L120.311 692.147L115.993 691.624L114.633 689.457L114.624 689.466ZM146.597 683.324L148.573 686.124L153.709 686.372L155.142 689.283L151.531 691.495L147.406 693.891L146.754 689.384L142.132 687.373L146.597 683.334V683.324ZM161.436 668.847L168.4 667.314L173.049 668.333L173.545 672.17L169.319 675.466L163.218 677.284L158.091 673.226L158.459 670.958L157.246 670.141L161.445 668.856L161.436 668.847ZM205.831 670.683L208.781 669.306L211.656 672.813V675.438L206.079 677.504L201.798 672.308L201.531 669.214L205.831 670.692V670.683ZM235.085 657.94L238.889 656.683L243.391 658.803L246.111 663.944L246.065 666.093L241.223 666.469L237.217 662.668L235.095 657.94H235.085ZM218.676 605.06L218.042 596.412L221.919 596.146L228.231 601.912L235.618 588.765L239.22 592.281L246.965 592.731L238.77 578.143L228.314 564.455L225.971 552.924L222.728 542.302L207.044 533.388L198.665 540.053L159.286 541.045L152.974 520.333L147.654 518.259L140.35 525.465L130.262 514.026L116.204 516.184L110.802 532.305L89.1736 539.062L89.8995 525.649L85.3974 523.042L70.164 527.457L65.3037 530.157L58.9916 548.793L68.2713 564.914L69.5301 570.496L69.4382 581.035L58.9825 565.548L47.8101 565.098L49.7946 575.903L53.6719 573.204L61.0589 580.044L53.3044 591.749L58.9825 596.165L65.3772 588.416L68.2621 589.05L64.8351 596.256L67.7201 602.738L62.4922 615.792L75.4654 615.884L81.3272 618.492L83.5782 605.703L88.6224 612.543L97.2773 616.417L87.1799 617.408L81.8601 625.515L63.3007 623.89L64.293 628.838L79.4345 630.371L88.1721 641.36L79.0762 643.518L69.1626 634.512H64.8351L64.2011 641.085L72.5804 648.466L63.117 648.558L56.7223 636.311L57.8891 629.38L52.5694 624.881L48.6002 638.927L62.483 656.572L78.2493 654.323L81.318 659.721L72.4885 665.129L79.4253 676.026L75.64 687.281L80.6841 688.456L79.067 697.637L91.6819 694.038L95.8256 679.992L105.289 672.519L110.967 666.396L111.776 654.149L115.653 650.642L118.088 656.315L117.371 669.278L128.902 673.96L133.137 668.378L142.233 658.289L145.302 646.492L162.152 634.603L169.365 633.887L175.043 622.816L178.92 628.489L186.675 628.039L187.759 633.896L184.874 638.937L177.937 634.521L174.152 640.194L177.937 648.925L170.274 652.258V644.427L158.826 655.948L162.07 660.272L171.892 657.298L184.598 673.419L193.161 668.92L198.931 659.74L190.368 657.848L187.391 652.359L193.612 648.576L201.449 652.9L209.47 650.651L204.692 641.379L193.161 624.716L189.284 623.908L194.687 618.96L191.351 614.728L205.501 611.303L209.02 604.188L212.713 613.91L217.941 627.415L212.805 634.53L216.949 641.461L226.136 643.619L225.42 633.529L235.333 630.38L241.912 610.477L229.481 614.617L218.667 605.07L218.676 605.06ZM146.763 573.186L117.922 579.575L111.528 571.919H103.415L104.949 559.856L117.922 549.408H123.6L135.223 546.525L140.717 549.408L143.694 558.68L150.631 560.663L146.754 573.177L146.763 573.186ZM21.1195 575.306L22.6079 569.293L26.9813 567.273L30.344 563.436L33.9548 563.078L31.2261 567.411L30.5186 572.13L26.9813 578.033L21.1195 575.316V575.306ZM31.6028 578.033L34.9563 577.289L36.5734 580.585L32.8339 580.695L31.6028 578.033ZM42.4352 570.028L45.017 575.233L47.8468 580.594L45.0262 581.669L42.1136 577.326L39.1735 576.325L36.0864 570.542L42.4352 570.018V570.028ZM52.7531 599.681L57.9167 601.921L54.8296 606.382L59.5889 608.852L58.7619 613.066L51.8803 608.907L42.7935 610.036L49.2893 606.392L51.1912 604.069L52.7439 599.672L52.7531 599.681ZM42.1136 595.375L46.533 596.165L44.3187 599.001L42.7935 598.515L42.1044 595.384L42.1136 595.375ZM22.7273 597.239L25.4469 601.067L23.398 606.373L17.6373 607.31L11.3344 608.182L17.2973 600.222L19.3554 600.617L22.7365 597.239H22.7273ZM28.1757 609.082L28.286 606.281L32.053 606.456V609.798L28.9934 613.727L25.4469 616.215L21.9096 610.771L28.1757 609.082ZM26.9813 618.969L34.1478 616.775L34.5888 620.107L28.3686 620.814L26.9813 618.969ZM23.1592 623.559L34.5796 625.698L35.3973 632.657L30.096 629.517L26.9721 630.399L23.1592 623.559ZM13.7325 619.042L14.642 622.843L7.72362 624.652L5.27966 628.792L0.0426025 628.104V622.467L4.66408 620.355L13.7325 619.042ZM11.1323 629.132L14.642 633.41L9.79088 640.176L3.53397 636.889L3.65341 633.942L8.00844 631.666L11.1323 629.132ZM20.9173 652.726L16.6358 653.699L15.7721 648.42L16.6358 643.554L20.9173 652.726ZM24.3995 646.657L26.8251 649.733L26.0901 654.984L20.8622 659.125L18.6939 657.803L21.5145 655.149L24.6016 652.717L21.5145 646.015L24.4087 646.657H24.3995ZM45.0078 652.753L49.4914 653.699L54.0394 657.876L57.9167 657.399L61.8307 664.357L58.7344 678.055L53.4238 676.118L53.1574 679.478L39.6054 686.483L32.0805 685.959L33.3668 682.92L30.4727 680.231L28.2951 681.369L27.0915 678.89L31.5936 670.215L35.3881 669.627L39.0265 664.211L48.3521 661.19L48.6645 657.931L44.9986 652.772L45.0078 652.753ZM17.674 693.937L24.2066 694.24V697.159L21.4135 698.491L16.8012 697.123L17.6648 693.928L17.674 693.937ZM83.3118 715.346L88.8337 716.209L92.0954 718.247L88.8061 718.201L85.7006 721.102L80.2982 722.571L79.0395 720.047L79.4989 716.484L83.3118 715.355V715.346ZM87.2809 706.735L92.2699 708.323L92.7569 711.343L90.1567 713.464L86.1233 712.326L87.2717 706.726L87.2809 706.735Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="gyeongnam" d="M428.829 525.64L425.043 530.138L420.358 530.772L409.36 540.586L399.896 550.491L385.481 558.24L375.834 563.463L381.236 571.386L375.2 573.011L373.491 569.954L362.768 570.67V563.913L357.807 565.621L352.671 561.205L350.144 551.391L346.901 557.781L354.646 574.801L350.227 577.051L345.358 571.469L334.543 568.944L333.643 572.993L323.546 577.95L321.837 584.882L334.543 578.042L333.643 587.14L327.423 589.031L328.507 601.636L332.476 601.902L331.217 606.584L324.189 611L326.44 606.584L318.777 605.685L315.176 603.252L317.969 599.111L314.459 595.421L309.231 600.645L305.988 597.587L300.576 597.404L298.959 603.261L288.779 602.27L287.603 598.579L278.948 594.255L281.199 573.002L272.728 579.575L271.552 587.14L266.59 588.223L263.705 583.725L260.012 592.731H246.947L238.751 578.143L228.296 564.455L225.953 552.924L222.709 542.302L232.347 522.041L224.602 501.063L234.332 468.014L261.004 445.319L269.834 455.675L286.51 459.641L298.408 472.246L300.3 487.917L312.823 489.358L326.431 494.307L343.465 486.108L346.258 494.931L371.58 498.621L388.338 487.274L401.762 488.899L402.57 493.765L398.151 498.631L423.748 516.193L428.792 525.649L428.829 525.64ZM253.654 602.921L250.135 606.639L255.556 629.361L260.113 630.399L263.044 623.421L265.203 623.256L269.815 632.703L273.49 631.831L279.527 633.144L279.848 629.361L281.511 615.994L275.861 614.682L268.152 615.306L262.355 612.276L260.673 607.273L263.237 603.013V597.624L258.119 596.376L253.645 602.94L253.654 602.921ZM272.287 599.883L267.491 606.107L268.988 610.541L275.594 610.706L282.825 611.909L278.286 603.325L275.144 604.95L274.474 599.167L272.296 599.892L272.287 599.883ZM301.761 617.638L303.92 616.04L305.152 613.956L301.532 611.423L299.29 613.589L301.761 617.647V617.638ZM361.105 582.412L360.398 589.013L352.855 593.319L352.202 601.921L346.414 600.213L337.125 606.639L341.297 615.627L350.356 611.927L346.828 622.357L350.126 623.743L346.828 631.675L361.758 628.82L359.516 624.101L360.876 616.839L368.979 619.749L366.857 612.625L368.345 604.95L366.14 603.959L366.921 595.476L365.369 580.622L361.115 582.421L361.105 582.412ZM376.054 577.537L379.077 587.186L381.162 582.531L381.227 577.537H376.054Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="sejong" d="M190.736 349.511L184.341 352.66V355.359L183.165 362.024L175.061 365.54L168.749 366.164L163.522 361.033L159.828 349.603L161.629 338.347L156.401 335.015L157.219 322.584L153.158 317.544L157.219 312.862L177.046 321.143L172.627 327.716L178.571 339.063L186.142 341.23L190.736 349.511Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="gwanju" d="M150.64 560.663L146.763 573.186L117.922 579.575L111.528 571.919H103.415L104.949 559.856L117.922 549.408H123.6L135.232 546.525L140.727 549.408L143.703 558.69L150.64 560.663Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="incheon" d="M115.192 178.507L118.435 172.567L112.041 172.925L100.326 166.352L94.1979 171.934L98.4335 176.524L100.593 188.679L95.181 187.78L99.7749 200.21L110.865 205.158L115.367 193.003L111.131 184.631L115.192 178.507ZM67.3603 134.009L63.0696 136.653L62.2611 146.871L67.3603 160.688L62.2611 168.298L80.5173 166.325L78.1744 141.179L67.3603 134V134.009ZM46.4488 141.73L55.2692 140.683L56.583 136.414L44.648 135.258L42.0479 141.216L46.4488 141.73ZM56.583 159.366L61.1769 156.483L57.3364 151.553L55.3427 145.384L49.9402 152.939L56.583 159.366ZM87.3438 186.999L87.5 182.914L80.2508 181.904L76.2358 190.938L87.3438 186.99V186.999ZM85.5614 220.49L86.5169 227.191L83.9903 233.921L92.5625 227.834L89.2273 223.244L85.5614 220.499V220.49ZM70.6771 228.486L74.3614 227.201L77.0718 223.235L75.3905 221.307L70.7966 222.344L70.6771 228.486ZM23.7733 229.138L26.7685 229.542L31.2338 231.056L34.0361 227.843L26.9982 223.253L23.7733 229.138ZM60.3225 191.727L61.9119 195.271L64.3008 194.995L67.3603 196.63L68.9406 193.049L65.4493 191.167L60.3225 191.727Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="seoul" d="M168.125 176.349L167.04 182.472L158.928 195.086H148.389L131.079 196.078L115.313 178.515L118.556 172.575L128.112 174.999L133.698 166.268L141.719 164.111L145.587 157.088H156.585L159.653 176.982L168.125 176.349Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="daejeon" d="M210.021 366.707L204.168 378.687L202.992 394.533L197.048 400.923L189.211 395.258L188.31 389.667H185.692L182.274 402.997L170.284 386.518L175.061 365.541L183.165 362.025L184.341 355.36L190.286 354.46L190.561 359.326L202 358.242L202.992 365.541L210.021 366.707Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="daegu" d="M370.789 442.345L368.989 452.343L364.128 462.249L363.136 472.962H356.282L354.389 468.73L345.201 474.67L343.483 486.109L326.458 494.307V487.908L321.864 480.343L331.861 477.92L326.816 468.73L329.61 462.79L335.38 460.991L324.924 454.5L333.671 443.52L339.257 445.32L342.05 431.274L358.9 427.308L368.989 434.156L370.789 442.345Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="busan" d="M442.436 534.104L434.599 546.525L427.12 559.855L418.557 562.646L416.572 567.512H409.902L403.057 577.592L398.73 579.575L396.745 567.512L381.245 571.386L375.843 563.454L385.481 558.24L399.896 550.491L409.36 540.586L420.358 530.772L425.044 530.138L428.829 525.64L436.492 527.439L442.436 534.104Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="ulsan" d="M461.813 483.584L460.095 504.213L450.641 512.943L448.39 525.64L442.436 534.104L436.492 527.439L428.829 525.64L423.785 516.184L398.188 498.622L402.607 493.765L401.789 488.899L410.086 483.501L413.513 475.845H431.438L434.599 482.96L450.641 481.335L461.813 483.584Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="chungbuk" d="M354.665 264.775L328.709 287.377L327.901 298.274L311.767 303.673L302.937 293.776L281.667 304.214L279.867 319.078L263.016 319.702L244.898 336.814L256.346 348.519L254.903 363.915L246.974 385.352L275.089 393.541L270.587 402.997L256.346 426.141L238.319 430.639L222.911 422.625L216.517 408.936L215.616 399.214L211.831 393.541L202.992 394.532L204.168 378.687L210.021 366.706L202.992 365.54L202 358.242L190.561 359.325L190.285 354.459L184.341 355.359V352.66L190.736 349.511L186.142 341.23L178.571 339.064L172.626 327.716L177.046 321.143L186.776 310.971L191.728 307.639L177.046 287.377L209.038 262.975L224.62 254.786V247.13L232.191 245.33L234.268 242.622L248.775 239.749L249.584 246.23H259.047V234.525L270.587 231.192L277.074 242.172L292.573 233.891L313.843 238.215L306.364 247.671L319.338 248.929L354.665 264.775Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="gyeonggi" d="M241.93 193.011L244.632 197.693L237.695 238.032L234.268 242.622L232.191 245.322L224.62 247.121V254.777L209.029 262.976L177.037 287.378L159.828 278.555L150.456 282.604L138.65 281.97L143.611 275.305L140.635 269.815L136.849 278.28L124.859 273.331L119.181 265.317L130.353 263.517L126.21 251.904L122.241 259.377C122.241 259.377 112.952 259.193 112.685 259.111C112.419 259.019 112.869 247.13 112.869 247.13L123.591 240.291L116.471 235.333L102.321 245.505L103.856 238.032L100.337 236.591L103.856 231.193L99.7121 224.978L110.884 226.327L116.746 228.934L118.547 224.886L121.34 222.453L123.417 217.229L115.662 217.587L105.482 211.556L110.976 205.166L115.478 193.011L111.243 184.638L115.304 178.515L131.07 196.077L148.371 195.086H158.918L167.031 182.481L168.115 176.357L159.644 176.991L156.575 157.088H145.578L141.7 164.111L133.679 166.268L128.093 174.999L118.538 172.566L112.143 172.924L100.429 166.351L94.3005 171.932L87.8139 165.809L84.1204 144.106L98.7198 144.29L99.8867 158.336L110.793 162.926L103.856 151.129L103.222 130.418H101.237V110.965L126.559 95.8351L140.166 69.7257L145.844 66.127L150.438 70.809L167.555 86.0303L175.668 84.2309L182.696 81.2565L183.597 90.2625L201.44 94.6784L204.325 107.733L221.359 124.928L209.01 141.224L210.269 166.883L249.565 185.795L241.903 193.002L241.93 193.011Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="gangwon" d="M461.813 283.054L456.135 328.442L437.392 325.917L435.949 295.576L425.319 293.235L413.595 274.507L424.685 263.334L372.599 253.254L369.898 267.208L354.665 264.775L319.338 248.93L306.364 247.672L313.843 238.216L292.573 233.892L277.074 242.173L270.587 231.193L259.047 234.525V246.231H249.584L248.775 239.749L234.268 242.623L237.695 238.032L244.631 197.693L241.93 193.011L249.584 185.804L210.297 166.902L209.038 141.233L221.377 124.937L204.352 107.742L201.467 94.6784L183.624 90.2718L182.724 81.2657L175.695 84.2402L167.582 86.0396L150.456 70.8183L145.862 66.1362L164.431 54.431L202.818 51.0067L249.767 53.2651L283.468 49.8408L304.196 32.5539L308.524 7.51857L319.338 0.945312L326.366 14.7253L360.701 90.2718L406.208 151.139L442.436 219.846L461.813 283.054Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="chungnam" d="M222.912 422.625L216.783 428.39L200.117 429.565L181.732 408.946L179.205 412.187L155.868 417.41L154.426 414.803L155.868 408.23L151.274 406.072L124.418 412.554L118.565 419.761L100.631 425.25L90.9837 406.43H77.4684L88.7327 395.441L82.4206 388.51L86.1141 377.888L80.2615 373.922L86.1141 368.157L79.5357 361.134L85.6639 357.26L78.2769 354.469L74.5834 333.757L79.3611 323.852L76.7517 308.814L67.5639 321.869L59.9932 324.118L62.6944 312.229L57.4665 309.622L55.0317 319.344L51.8803 328.166L49.1791 311.871L36.6561 319.344L34.6715 314.028L41.3419 310.788L35.8476 306.647L32.9626 311.421L30.5278 305.931L34.2213 299.358L39.3573 295.218L39.5411 288.286L40.7998 283.246L49.271 286.845L49.4547 276.039L53.5984 271.991L55.1328 284.146L51.8895 293.694L55.8586 296.484L57.4757 291.711L64.1461 288.204L66.7554 278.564L60.719 275.415V266.409L71.2574 266.143L77.1101 289.553L79.5448 273.35L87.6577 279.831L78.2861 265.785L82.0715 264.61L82.7973 258.67L99.2895 274.965L106.502 269.108L109.019 273.34L116.59 273.79L117.316 281.988L121.009 281.089L121.552 289.911L124.437 302.7L126.237 295.319H130.739L127.762 287.396L138.668 281.998L150.475 282.631L159.846 278.582L177.055 287.405L191.746 307.666L186.785 310.999L177.055 321.171L157.228 312.89L153.176 317.572L157.228 322.612L156.419 335.043L161.647 338.375L159.846 349.631L163.54 361.069L168.768 366.201L175.08 365.568L170.302 386.545L182.292 403.024L185.719 389.694H188.329L189.229 395.276L197.066 400.95L203.02 394.56L211.849 393.569L215.635 399.242L216.535 408.964L222.93 422.652L222.912 422.625ZM57.9167 335.134L56.7315 348.272L60.6547 351.476L57.9167 355.35L60.4434 358.168L60.6547 361.446L68.253 361.418L64.7249 354.239L66.002 348.309L61.8307 345.903L63.264 342.975L60.3974 333.308L57.9075 335.134H57.9167Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="jeju" d="M134.69 757.654L129.095 769.626L119.19 778.182L87.6484 789.263L57.641 790.245L50.6031 794.753L40.9651 789.079L34.4785 781.156L38.172 770.892L53.6719 755.313L82.2368 746.573L101.439 741.35L119.006 740L131.621 747.39L134.69 757.654Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2.06" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="gyeongbuk" d="M477.497 424.608L461.813 483.583L450.641 481.334L434.599 482.959L431.447 475.844H413.513L410.086 483.501L401.789 488.908L388.366 487.283L371.607 498.63L346.285 494.94L343.492 486.117L345.201 474.678L354.389 468.738L356.282 472.971H363.136L364.128 462.257L368.998 452.351L370.799 442.354L368.998 434.155L358.9 427.316L342.05 431.282L339.257 445.328L333.671 443.529L324.924 454.518L335.379 460.999L329.61 462.799L326.816 468.738L331.861 477.919L321.855 480.352L326.449 487.916V494.306L312.842 489.358L300.319 487.916L298.426 472.245L286.528 459.641L269.852 455.675L261.022 445.319V434.155L256.337 426.141L270.578 402.997L275.08 393.541L246.965 385.343L254.894 363.915L256.337 348.519L244.889 336.814L262.998 319.702L279.848 319.068L281.649 304.214L302.919 293.767L311.748 303.673L327.882 298.274L328.691 287.377L354.646 264.775L369.88 267.208L372.581 253.253L424.667 263.343L413.586 274.506L425.301 293.234L435.931 295.575L437.373 325.917L456.117 328.442V362.024L450.622 392.999L455.492 410.112L451.615 421.009L456.659 426.949L475.402 415.877L477.478 424.608H477.497ZM479.242 249.159L492.408 251.05L496.727 239.73L493.759 231.192L476.725 236.792L479.233 249.159H479.242Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="3.04" stroke-linecap="round" stroke-linejoin="round"/>
							<path class="region" data-name="" d="M500.098 252.604L497.971 251.658L501.627 248.004L505.838 252.917L503.072 254.688L500.098 252.604Z" fill="white" stroke="#497B77" stroke-opacity="0.2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
							</g>
							<defs>
							<filter id="filter0_d_1518_345" x="-4.98743" y="-0.0546875" width="515.826" height="803.837" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
							<feFlood flood-opacity="0" result="BackgroundImageFix"/>
							<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
							<feOffset dy="4"/>
							<feGaussianBlur stdDeviation="2"/>
							<feComposite in2="hardAlpha" operator="out"/>
							<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
							<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_1518_345"/>
							<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_1518_345" result="shape"/>
							</filter>
							</defs>
						</svg>
						<button class="map-btn incheon" data-region="incheon">인천<br><span style="font-size: 13px;">(2)</span></button>
						<button data-region="seoul" disabled style="cursor: not-allowed; opacity: 0.5;"></button>
						<button class="map-btn gyeonggi" data-region="gyeonggi">경기<br><span style="font-size: 13px;">(5)</span></button>
						<button class="map-btn gangwon" data-region="gangwon">강원<br><span style="font-size: 13px;">(4)</span></button>
						<button class="map-btn chungnam" data-region="chungnam">충남<br><span style="font-size: 13px;">(7)</span></button>
						<button data-region="sejong" disabled style="cursor: not-allowed; opacity: 0.5;"></button>
						<button class="map-btn chungbuk" data-region="chungbuk">충북<br><span style="font-size: 13px;">(3)</span></button>
						<button class="map-btn daejeon" data-region="daejeon">대전<br><span style="font-size: 13px;">(2)</span></button>
						<button class="map-btn jeonbuk" data-region="jeonbuk">전북<br><span style="font-size: 13px;">(6)</span></button>
						<button class="map-btn gwanju" data-region="gwanju">광주<br><span style="font-size: 13px;">(3)</span></button>
						<button class="map-btn jeonnam" data-region="jeonnam">전남<br><span style="font-size: 13px;">(7)</span></button>
						<button class="map-btn gyeongbuk" data-region="gyeongbuk">경북<br><span style="font-size: 13px;">(2)</span></button>
						<button class="map-btn daegu" data-region="daegu">대구<br><span style="font-size: 13px;">(1)</span></button>
						<button class="map-btn gyeongnam" data-region="gyeongnam">경남<br><span style="font-size: 13px;">(5)</span></button>
						<button class="map-btn ulsan" data-region="ulsan">울산<br><span style="font-size: 13px;">(1)</span></button>
						<button class="map-btn busan" data-region="busan">부산<br><span style="font-size: 13px;">(2)</span></button>
						<button class="map-btn jeju" data-region="jeju">제주</button>
						<!-- <div class="map-area">
							<button v-if="item.count > 0" type="button" class="map-pin" :class="{ 'is-active': item.active }" :style="`left: ${item.x}px; top:${item.y}px`" v-for="(item, _) in pinList" @click="onClickMap(item)"></button>
						</div> -->
					</div>
					<div class="flex-r" :class="{ 'is-active': visibleInfo }">
						<!-- 지도 클릭시 정보 -->
						<map-info @closeModal="handleModal" :visible="visibleInfo" :arDcdOptions="arDcdOptions" :localEventList="localEventList" :callAutoPlay="callAutoPlay" :localMallOnlyUrl="selectedLocalMallUrl" />
					</div>
				</div>
			</div>
		</div>
		<div class="container">
			<div class="festival-search">
				<!-- <div class="flex-l"> -->
				<div class="dropdown-style">
					<DropDown ref="dropDown1" id="dropDown1" placeholder="지역 선택">
						<div class="dropdown-item" v-for="(dcd, idx) in arOptions" :key="idx" :data-value="dcd.dcd">
							<button type="button" @click="onClickArDropDn($event, dcd.dcd)" class="text-link">
								<span class="dropdown-text">{{ dcd.dcdVal }}</span>
							</button>
						</div>
					</DropDown>
				</div>
				<!-- </div> -->
				<!-- <div class="flex-r"> -->
				<div class="category-search-area">
					<!-- <input type="text" class="category-search-input" v-model="prtcCoSrchFilter.prtcCoNm" placeholder="행사명을 입력하세요." @keyup.enter="onKeyUpSrch" /> -->
					<input type="text" class="category-search-input" v-model="arEventSrchFilter.arEventNm" placeholder="행사명을 입력하세요." @keyup.enter="onKeyUpSrch" />
					<button class="category-search-button" @click="onClickSrch">
						<i class="icon">
							<img src="@/assets/img/category/search_icon.svg" alt="검색" />
						</i>
					</button>
				</div>
				<!-- </div> -->
			</div>
			<!-- pc -->
			<section v-if="!isMobile" class="festival-table">
				<h3 class="festival-table-title">행사목록</h3>
				<div class="table">
					<table class="table is-bordered">
						<caption>
							번호, 행사명, 지역, 기간, 소개 항목의 행사 목록
						</caption>
						<colgroup>
							<col style="width: 60px" />
							<col style="width: 20%" />
							<col style="width: 10%" />
							<col style="width: 30%" />
							<col />
						</colgroup>
						<thead>
							<tr>
								<th scope="col">번호</th>
								<th scope="col">행사명</th>
								<th scope="col">지역</th>
								<th scope="col">기간</th>
								<th scope="col">소개</th>
							</tr>
						</thead>
						<!-- <tbody v-if="prtcCoList.length > 0">
							<tr v-for="(item, idx) in prtcCoList" :key="idx">
								<td>{{ idx + 1 }}</td>
								<td>{{ item.prtcCoNm }}</td>
								<td>{{ item.arNm }}</td>
								<td>{{ item.prtcFldNm }}</td>
								<td class="text-left">{{ item.coIntro }}</td>
							</tr>
						</tbody> -->
						<tbody v-if="arEventTabularList.length > 0">
							<tr v-for="(item, idx) in arEventTabularList" :key="idx">
								<td>{{ (pagingState.pageNo - 1) * pagingState.pageSize + idx + 1 }}</td>
								<td>{{ item.arEventNm }}</td>
								<td>{{ item.arNm }}</td>
								<td>{{ item.date }}</td>
								<td class="text-left">{{ item.eventIntro }}</td>
							</tr>
						</tbody>
						<tbody v-else>
							<tr>
								<td colspan="5" class="data-none">
									<span>등록된 데이터가 없습니다.</span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>
			<!--// pc -->
			<!-- mobile -->
			<div v-if="isMobile" class="mb-festival-table">
				<ul v-if="arEventTabularList.length > 0">
					<li v-for="(item, idx) in arEventTabularList" :key="idx">
						<div class="tit-box">
							<span>{{ (pagingState.pageNo - 1) * pagingState.pageSize + idx + 1 }}</span>
							<strong>{{ item.arEventNm }}</strong>
						</div>
						<ul class="event-info">
							<li><span><img src="@/assets/img/common/ico-location.svg" alt=""></span>{{ item.arNm }}</li>
							<li><span><img src="@/assets/img/common/ico-calendar.svg" alt=""></span>{{ item.date }}</li>
						</ul>
						<p class="desc">{{ item.eventIntro }}</p>
					</li>
				</ul>
				<div v-else class="data-none">
					<span>등록된 데이터가 없습니다.</span>
				</div>
			</div>
			<!-- mobile -->
		</div>
		<div class="pagination-wrap">
			<!-- <portal-pagination 
				page-name="Festival" 
				:total-count="pagingState.totalCount" 
				:page-size="pagingState.pageSize" 
				:page-no="pagingState.pageNo" 
				:query="queries" 
				:parent-method-name="'getPrtcCoList'" 
				@getPrtcCoList="getPrtcCoList"
			></portal-pagination> -->
			<portal-pagination page-name="Festival" :total-count="pagingState.totalCount" :page-size="pagingState.pageSize" :page-no="pagingState.pageNo" :query="queries" :parent-method-name="'getArEventTabularList'" @getArEventTabularList="getArEventTabularList"></portal-pagination>
		</div>
	</main>
</template>

<style>
.region {
  pointer-events: all;
  cursor: pointer;
}
.region.active {
  fill: #A0D29E;
  stroke: #A0D29E;
  stroke-opacity: 1;
  filter:drop-shadow(1px 3px 1px rgba(0,0,0,0.2));
}
.map-btn {
position: absolute;
transform: translate(-50%, -50%); /* 가운데 기준 정렬 */
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
width: 56px;
height: 56px;
border-radius: 50%;
text-align: center;
font-size: 16px;
line-height: 1.1;
color: #fff;
background: #2BAAA2;
}
.map-btn.incheon {top:22.9%; left:16.8%;}
.map-btn.seoul {top:21%; left:28.8%;}
.map-btn.gyeonggi {top:25%; left:35%;}
.map-btn.gangwon {top:20%; right:26%;}
.map-btn.chungnam {top:45%; left:23%;}
.map-btn.sejong {top:41%; left:31%;}
.map-btn.chungbuk {top:36%; left:48%;}
.map-btn.daejeon {top:48%; left:38%;}
.map-btn.jeonbuk {bottom:32%; left:34%;}
.map-btn.gwanju {bottom:17%; left:18%;}
.map-btn.jeonnam {bottom:15%; left:32%;}
.map-btn.gyeongbuk {bottom:48%; right:18%;}
.map-btn.daegu {bottom:37%; right:21%;}
.map-btn.gyeongnam {bottom:25%; right:30%;}
.map-btn.ulsan {bottom:33.4%; right:2%;}
.map-btn.busan {bottom:25%; right:7%;}
.map-btn.jeju {bottom:-2%; left:17%;}
@media(max-width:1024px) {
	.map-btn {
		width:44px;
		height:44px;
		font-size:15px;
	}
}
@media(max-width:800px){
	.map-btn {
		border-radius: 50%;
		width:45px;
		height:45px;
		font-size:16px;
	}
}
</style>

<script>
import Icon from '@/components/common/Icon';
import PageHeader from '@/components/content/PageHeader';
import DropDown from '@/components/common/DropDown';
import PortalPagination from '@/components/PortalPaginationRoute';
import MapInfo from './MapInfo';

import { mapGetters } from 'vuex';
import { ACT_GET_COMMON_CODE_LIST, ACT_GET_AR_EVENT_LIST, ACT_GET_PRTC_CO_LIST } from '@/store/_act_consts';
import { MUT_SET_COMMON_CODE_ITEMS } from '@/store/_mut_consts';

import { lengthCheck, getItems, getCheckItems, setPaging } from '@/assets/js/utils';

export default {
	name: 'Festival',
	components: { PageHeader, DropDown, Icon, PortalPagination, MapInfo },
	data: () => ({
		visibleInfo: false,

		callAutoPlay: true,
		arDcdOptions: [],
		pinList: [
			{
				x: 306,
				y: 179,
				label: '강원도',
				dcd: 1504001,
			},
			{
				x: 179,
				y: 242,
				label: '경기도',
				dcd: 1504002,
			},
			{
				x: 295,
				y: 532,
				label: '경상남도',
				dcd: 1504003,
			},
			{
				x: 355,
				y: 364,
				label: '경상북도',
				dcd: 1504004,
			},
			{
				x: 128,
				y: 568,
				label: '광주',
				dcd: 1504005,
			},
			{
				x: 346,
				y: 460,
				label: '대구',
				dcd: 1504006,
			},
			{
				x: 190,
				y: 383,
				label: '대전',
				dcd: 1504007,
			},
			{
				x: 409,
				y: 557,
				label: '부산',
				dcd: 1504008,
			},
			{
				x: 144,
				y: 194,
				label: '서울',
				dcd: 1504009,
			},
			{
				x: 169,
				y: 344,
				label: '세종',
				dcd: 1504010,
			},
			{
				x: 430,
				y: 506,
				label: '울산',
				dcd: 1504011,
			},
			{
				x: 104,
				y: 197,
				label: '인천',
				dcd: 1504012,
			},
			{
				x: 184,
				y: 573,
				label: '전라남도',
				dcd: 1504013,
			},
			{
				x: 133,
				y: 451,
				label: '전라북도',
				dcd: 1504014,
			},
			{
				x: 87,
				y: 737,
				label: '제주도',
				dcd: 1504015,
				localMallUrl: 'https://buly.kr/3COaAE2',
			},
			{
				x: 121,
				y: 345,
				label: '충청남도',
				dcd: 1504016,
			},
			{
				x: 232,
				y: 308,
				label: '충청북도',
				dcd: 1504017,
			},
		],
		arEventList: [],
		localEventList: [],
		selectedLocalMallUrl: '',

		arEventSrchFilter: {
			arDcd: null,
			arEventNm: '',
		},
		arEventTabularList: [],

		// prtcFldOptions: [],
		// prtcCoSrchFilter: {
		// 	arDcd: null,
		// 	prtcCoNm: '',
		// },
		// prtcCoList: [],
		pagingState: {
			hasMore: false,
			totalCount: 0,
			pageSize: 10,
			pageNo: 1,
		},
	}),
	computed: {
		...mapGetters('common', ['isMobile', 'commonCode', 'campn']),
		...mapGetters('festival', ['PAGING']),

		campnId() {
			return this.campn.campnId;
		},
		arOptions() {
			let options = [...this.arDcdOptions];
			options.splice(0, 1);
			options.unshift({ dcd: null, dcdVal: '전체' });
			return options;
		},

		queries() {
			let result = {};
			// result.prtcCoNm = this.prtcCoSrchFilter.prtcCoNm;
			// result.arDcd = this.prtcCoSrchFilter.arDcd;
			result.arEventNm = this.arEventSrchFilter.arEventNm;
			result.arDcd = this.arEventSrchFilter.arDcd;

			return result;
		},
	},
	watch: {
		arDcdOptions(newValue) {
			if (newValue.length > 0) this.getArEventList();
		},
		// prtcFldOptions(newValue) {
		// 	if (newValue.length > 0) this.getPrtcCoList();
		// },
	},
	async created() {
		await this.getCommonCdList();
		this.initializePinList();
	},
	mounted() {
		/* if (this.arDcdOptions.length > 0 && this.arEventList.length === 0) {
			this.getArEventList();
		} */


		// 지도 각 지역 클릭 시 active
		const buttons = document.querySelectorAll(".map-btn");
		const regions = document.querySelectorAll(".region");

		const regionToDcd = {
			gangwon: 1504001,
			gyeonggi: 1504002,
			gyeongnam: 1504003,
			gyeongbuk: 1504004,
			gwanju: 1504005,
			daegu: 1504006,
			daejeon: 1504007,
			busan: 1504008,
			seoul: 1504009,
			sejong: 1504010,
			ulsan: 1504011,
			incheon: 1504012,
			jeonnam: 1504013,
			jeonbuk: 1504014,
			jeju: 1504015,
			chungnam: 1504016,
			chungbuk: 1504017,
		};

		const setActive = (regionName) => {
			regions.forEach(r => r.classList.remove("active"));
			buttons.forEach(b => b.classList.remove("active"));

			const targetRegion = document.querySelector(
				`.region[data-name="${regionName}"]`
			);
			if (targetRegion) targetRegion.classList.add("active");

			const targetBtn = document.querySelector(
				`.map-btn[data-region="${regionName}"]`
			);
			if (targetBtn) targetBtn.classList.add("active");

			if (regionToDcd[regionName]) {
				this.onClickMap({ dcd: regionToDcd[regionName] });
			}
		};

		buttons.forEach(btn => {
			btn.addEventListener("click", () => {
				const regionName = btn.dataset.region;
				setActive(regionName);
			});
		});

		regions.forEach(region => {
			region.addEventListener("click", () => {
				const regionName = region.dataset.name;
				if (!regionName || regionName === 'seoul' || regionName === 'sejong') return; // data-name 없는 path 혹은 서울, 세종 등 제외
				setActive(regionName);
			});
		});
	},
	methods: {
		// event ======================================================================

		onClickMap(pin) {
			this.setPinActive(pin.dcd);
			this.handleAutoPlay();
		},
		handleModal(val) {
			this.visibleInfo = val;
		},

		onClickArDropDn(e, arDcd) {
			this.$refs.dropDown1.selectDropdownItem(e);
			// this.prtcCoSrchFilter.arDcd = arDcd;
			// this.getPrtcCoList();

			this.arEventSrchFilter.arDcd = arDcd;
			this.getArEventTabularList();
		},
		onKeyUpSrch() {
			// this.getPrtcCoList();
			this.getArEventTabularList();
		},
		onClickSrch() {
			// this.getPrtcCoList();
			this.getArEventTabularList();
		},

		// custom fn ==================================================================
		initializePinList() {
			this.pinList = this.pinList.map((pin) => ({
				...pin,
				// label: dcd.dcdVal,
				count: 0,
				active: false,
				localEventList: [],
			}));
		},
		setPinActive(dcd) {
			let activeDcd = dcd;

			this.pinList.forEach((item, _) => {
			if (activeDcd != null && activeDcd == item.dcd) {
				item.active = true;
				this.localEventList = [...item.localEventList];
				this.selectedLocalMallUrl = item.localMallUrl || '';
				this.triggerClickArDropDn(activeDcd);
				} else {
					item.active = false;
				}
			});

			// dcd가 있으면 (지역 클릭 시) 항상 패널 표시 (축제 없어도 안내문 표시)
			if (activeDcd != null) {
				this.visibleInfo = true;
			} else {
				// dcd가 null인 경우(초기 자동 선택): 모바일은 카드 표시 안 함
				if (this.isMobile) {
					this.visibleInfo = false;
					return;
				}
				// PC: 랜덤 지역 선택 후 카드 표시
				const activeEventList = this.pinList.filter((x) => x.count > 0);
				if (activeEventList.length > 0) {
					activeDcd = activeEventList[Math.floor(Math.random() * activeEventList.length)].dcd;
					this.pinList.forEach((item) => {
						if (activeDcd == item.dcd) {
							item.active = true;
							this.localEventList = [...item.localEventList];
							this.triggerClickArDropDn(activeDcd);
						} else {
							item.active = false;
						}
					});
					this.visibleInfo = true;
				} else {
					this.localEventList = [];
					this.visibleInfo = false;
				}
			}
		},
		triggerClickArDropDn(activeDcd = '') {
			this.arEventSrchFilter.arEventNm = '';
			this.arEventSrchFilter.arDcd = activeDcd;
			this.$refs.dropDown1.setDropdownItemByValue(activeDcd);
			this.getArEventTabularList(1);
		},

		removeHhmmssFromYmd(ymd) {
			return ymd.substring(0, 10);
		},
		getDayNm(ymd) {
			return new Date(ymd).toLocaleDateString('ko-KR', { weekday: 'long' }).substring(0, 1);
		},

		handleAutoPlay() {
			this.callAutoPlay = true;
		},

		// promise ====================================================================
		async getCommonCdList() {
			const getArDcdOptions = () => {
				this.arDcdOptions = this.commonCode.filter((x) => x.dbColumn === 'AR_DCD').map((y) => ({ dcd: y.dcd, dcdVal: y.dcdVal }));
				// this.getPrtcCoList();
				this.getArEventTabularList();
			};
			// const getPrtcFldOptions = () => {
			// 	this.prtcFldOptions = this.commonCode.filter((x) => x.dbColumn === 'PRTC_FLD_DCD').map((y) => ({ dcd: y.dcd, dcdVal: y.dcdVal }));
			// };

			if (this.commonCode.length === 0) {
				this.$store
					.dispatch(`common/${ACT_GET_COMMON_CODE_LIST}`, {})
					.then((res) => {
						this.$store.commit(`common/${MUT_SET_COMMON_CODE_ITEMS}`, getCheckItems(res));
					})
					.then(() => {
						getArDcdOptions();
						// getPrtcFldOptions();
					});
			} else {
				getArDcdOptions();
				// getPrtcFldOptions();
			}
		},

		async getArEventList() {
			const modelAttr = {
				campnId: this.campnId,
				arDcd: null,
				pageSize: 2 ** (31 - 1),
			};

			this.$store
				.dispatch(`festival/${ACT_GET_AR_EVENT_LIST}`, modelAttr)
				.then((res) => {
					// console.log(res);
					if (lengthCheck(res)) {
						this.arEventList = getItems(res).map((item) => {
							const bgngYmd = this.removeHhmmssFromYmd(item.eventBgngYmd);
							const bgngDayNm = this.getDayNm(bgngYmd);
							const endYmd = this.removeHhmmssFromYmd(item.eventEndYmd);
							const endDayNm = this.getDayNm(endYmd);

							const arNm = this.arDcdOptions.find((dcd) => dcd.dcd === item.arDcd)?.dcdVal || '-';

							return {
								...item,
								arNm: arNm,
								date: `${bgngYmd} (${bgngDayNm}) ~ ${endYmd} (${endDayNm})`,
							};
						});

						this.pinList.forEach((x, _) => {
							for (let event of this.arEventList) {
								if (x.dcd == event.arDcd) {
									x.localEventList.push({ ...event });
								}
							}
						});
						this.pinList = this.pinList.map((y) => ({ ...y, count: y.localEventList.length }));
					} else {
						this.arEventList = [];
					}
				})
				.then(() => this.setPinActive())
				.catch(console.error);
		},

		async getArEventTabularList(pageNum = this.pagingState.pageNo) {
			const modelAttr = {
				campnId: this.campnId,
				arEventNm: this.arEventSrchFilter.arEventNm,
				arDcd: this.arEventSrchFilter.arDcd,
				...this.pagingState,
				pageNo: pageNum,
			};

			this.$store
				.dispatch(`festival/${ACT_GET_AR_EVENT_LIST}`, modelAttr)
				.then((res) => {
					// console.log(res);
					if (lengthCheck(res)) {
						this.arEventTabularList = getItems(res).map((item) => {
							const bgngYmd = this.removeHhmmssFromYmd(item.eventBgngYmd);
							const bgngDayNm = this.getDayNm(bgngYmd);
							const endYmd = this.removeHhmmssFromYmd(item.eventEndYmd);
							const endDayNm = this.getDayNm(endYmd);

							const arNm = this.arDcdOptions.find((dcd) => dcd.dcd === item.arDcd)?.dcdVal || '-';

							return {
								...item,
								arNm: arNm,
								date: `${bgngYmd} (${bgngDayNm}) ~ ${endYmd} (${endDayNm})`,
							};
						});
						setPaging(this.pagingState, res);
					} else {
						this.arEventTabularList = [];
						this.pagingState = this.PAGING;
					}
				})
				.catch(console.error);
		},

		// async getPrtcCoList(pageNum = this.pagingState.pageNo) {
		// 	const modelAttr = {
		// 		campnId: this.campnId,
		// 		prtcCoNm: this.prtcCoSrchFilter.prtcCoNm,
		// 		arDcd: this.prtcCoSrchFilter.arDcd,
		// 		...this.pagingState,
		// 		pageNo: pageNum,
		// 	};

		// 	this.$store
		// 		.dispatch(`festival/${ACT_GET_PRTC_CO_LIST}`, modelAttr)
		// 		.then((res) => {
		// 			// console.log(res);
		// 			if (lengthCheck(res)) {
		// 				this.prtcCoList = getItems(res).map((item) => {
		// 					let arNm = this.arDcdOptions.find((dcd) => dcd.dcd == item.arDcd)?.dcdVal || '-';
		// 					if (!!item.sggNm) arNm = `${arNm} (${item.sggNm})`;

		// 					return {
		// 						...item,
		// 						arNm: arNm,
		// 						prtcFldNm: this.prtcFldOptions.find((dcd) => dcd.dcd == item.prtcFldDcd)?.dcdVal,
		// 					};
		// 				});
		// 				setPaging(this.pagingState, res);
		// 			} else {
		// 				this.prtcCoList = [];
		// 				this.pagingState = this.PAGING;
		// 			}
		// 		})
		// 		.catch(console.error);
		// },
	},
};

/* const svg = document.querySelector(".region");

svg.addEventListener("click", (e) => {
  e.target.classList.add("active");
}); */
</script>
